"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var addReadWriteRecipient_1 = require("./addReadWriteRecipient");
var datapoints_1 = require("../datapoints");
var owa_analytics_1 = require("owa-analytics");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('addHighlightedFindRecipient')(function addHighlightedFindRecipient(recipientWell) {
    // Only add highlighted recipient when find result is visible
    if (recipientWell.shouldShowFindResult) {
        var _a = datapoints_1.default.AddRecipientFromFindControl.datapoint, eventName = _a.name, customData = _a.customData;
        owa_analytics_1.logUsage(eventName, customData(recipientWell.findResultHightlightIndex, recipientWell.findResultType));
        var highlightedFindRecipient = recipientWell.findResultSet[recipientWell.findResultHightlightIndex];
        addReadWriteRecipient_1.default(recipientWell, true /* isValid */, highlightedFindRecipient, null /* newEmailAddress */);
    }
});
//# sourceMappingURL=addHighlightedFindRecipient.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/actions/addHighlightedFindRecipient.js
// module id = 3395
// module chunks = 2 3